/* eslint-disable jsx-a11y/anchor-is-valid */
import {FormattedDate, FormattedTime} from 'react-intl'
import {ICStatusLog} from '../../../../parcels/core/_models/_parcels-models'

interface Props {
  log: ICStatusLog
}

function CBuyoutStatusItem({log}: Props) {
  return (
    <tr>
      <td>
        <div className='d-flex flex-column'>
          <span className='text-dark fw-bold fs-6'>
            <FormattedDate year='numeric' month='numeric' day='numeric' value={log.createdAt} />
          </span>
          <span className='text-muted fw-normal fs-6'>
            <FormattedTime value={log.createdAt} hour='numeric' minute='numeric' second='numeric' />
          </span>
        </div>
      </td>

      <td>
        <span className='text-dark text-hover-primary d-block fs-6'>{log.name}</span>
      </td>
      <td>
        {log.user && (
          <span className='text-dark text-hover-primary d-block fs-6'>
            <span className='text-muted'>{log.user?.group?.title || ''}</span>
            <br />
            {log.user.firstName || ''}
          </span>
        )}
      </td>
    </tr>
  )
}

export {CBuyoutStatusItem}
